import React, { Component } from 'react';
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
// core components
import { Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getSuperCategory as getAllCategoryList,
  getAllSubCategory,
  getAllCategory as getCategoryList,
  addProduct
} from '../../store/actions/vendor/Vendor';
import { upload } from '../../store/actions/vendor/Vendor';
import CardHeader from '../../components/Card/CardHeader.js';
import CardBody from '../../components/Card/CardBody.js';
import Grid from '@material-ui/core/Grid';
import Textsms from '@material-ui/icons/Textsms';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import PlaylistAdd from '@material-ui/icons/PlaylistAdd';
import CustomInputWithIcons from '../../components/CustomInput/CustomInputWithIcons.js';
import CardFooter from '../../components/Card/CardFooter.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';
import { Divider } from '@material-ui/core';
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { DeleteOutline } from '@material-ui/icons';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

class AddProduct extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: null,
      hiddenSubcategory: 1,
      product: {
        name: '',
        image: '',
        subCategoryId: this.props?.subCategories[0]?.id || '',
        description: '',
        price: '',
        quantity: '',
        superCategoryId: '',
        categoryId: this.props?.categories[0]?.id || '',
        isGm: false,
        isMl: false,
        isOffer: false,
        offerPrice: null
      },
      varients: []
    };
  }

  componentDidMount() {
    this.props.getAllCategoryList();
  }

  componentDidUpdate(prevProps) {
    if(prevProps.categories !== this.props.categories){
      this.props.getAllSubCategory(this.props.categories[0].id);
    }
    if(prevProps.superCategories !== this.props.superCategories){
      this.props.getCategoryList(this.props.superCategories[0].id);
      this.setState((prevState) => ({
        product: {
          ...prevState.product,
          superCategoryId:
            this.props.superCategories[0] !== undefined
              ? this.props.superCategories[0].id
              : 'none'
        }
      }));
      
    }
  }
  onChange = (event) => {
    let product = this.state.product;
    product[event.target.name] = event.target.value;

    this.setState({
      product
    });
  };
  

  displayMessage = () => {
    this.setState({
      hiddenSubcategory: 0
    });
    alert(
      'Please add a subCategory first so that you can add product using this super-category.'
    );
  };

  onChangeSelect = (event) => {
    let product = this.state.product;
    product[event.target.name] = event.target.value;

    this.setState({
      product
    });
    this.props.getCategoryList(this.state.product.superCategoryId);
    setTimeout(() => {
      this.props.categories[0] === undefined
        ? alert(
          'Please add a category first so that you can add product using this super-category.'
        )
        : this.setState((prevState) => ({
          product: {
            ...prevState.product,
            categoryId:
              this.props.categories[0] !== undefined
                ? this.props.categories[0].id
                : 'none'
          }
        }));
    }, 4000);
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedOption)
    );
  };
  onChangeSelect2 = (event) => {
    let product = this.state.product;
    product[event.target.name] = event.target.value;
    this.setState({
      product
    });
    this.props.getAllSubCategory(this.state.product.categoryId);
    setTimeout(() => {
      this.props.subCategories[0] === undefined
        ? this.displayMessage()
        : this.setState({
          hiddenSubcategory: 1
        });
      // this.setState((prevState) => ({
      //   product: {
      //     ...prevState.product,
      //     subCategoryId:
      //       this.props.subCategories[0] !== undefined
      //         ? this.props.subCategories[0].id
      //         : 'none'
      //   }
      // }));
    }, 3000);
  };

  onUpload = (event) => {
    this.setState({
      imageUploadMessage: 'Uploading the file, please wait...'
    });

    let data = new FormData();
    data.append('files', event.target.files[0]);

    // Upload image
    this.props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          this.setState({
            imageUploadMessage: 'File uploaded successfully.'
          });
          let product = this.state.product;
          product.image = `${response.data.uploads[0].path}`;
          this.setState({
            product
          });
        } else {
          this.setState({
            imageUploadMessage: 'Please, try Again'
          });
        }
      })
      .catch((error) => {
        this.setState({
          imageUploadMessage:
            'An error occurred while executing the query. Please try Again'
        });
      })
      .then(() => {
        console.log('Image uploaded');
      });
  };

  handleVarient = () => {
    var varients = this.state.varients
    varients.push({})
    this.setState({
      varients
    })
  }

  handleVarientChange(index, event) {
    var varients = this.state.varients
    varients[index].heading = event.target.value
    this.setState({
      varients
    })
  }

  handleVarientAddProduct(index) {
    var varients = this.state.varients
    var product_variant = varients[index].product_variant
    if (product_variant) {
      product_variant.push({})
    } else {
      product_variant = [{}]
    }
    varients[index].product_variant = product_variant
    this.setState({
      varients
    })
  }

  handleVarientProductChange(index, product_index, key, event) {
    var varients = this.state.varients
    var product_variant = varients[index].product_variant
    product_variant[product_index][key] = event.target.value
    varients[index].product_variant = product_variant
    this.setState({
      varients
    })
  }

  onSubmit = (event) => {
    event.preventDefault();
    var product = this.state.product
    var varients = this.state.varients
    product.variant = varients
    this.props.addProduct(product).then(()=>{
      this.props.history.push('/vendor/products')
    });
    // setTimeout(() => {
    //   this.props.history.push(`/vendor/products`);
    // }, 3000);
  };

  onChangeQuantityType(event){
    let product = this.state.product;
    product[event.target.name] = event.target.value;

    this.setState({
      product
    });
  }

  changeIsGmMl(event){
    let product = this.state.product;
    product[event.target.name] = !product[event.target.name];

    this.setState({
      product
    });
  }

  changeIsOffer(event) {
    let product = this.state.product;
    product[event.target.name] = !product[event.target.name];
    if(!product[event.target.name]){
      product['offerPrice'] = null
    }

    this.setState({
      product
    });
  }

  deleteProductVariant(index, product_index){
    var varients = this.state.varients
    var product_variant = varients[index].product_variant
    product_variant.splice(product_index, 1);
    varients[index].product_variant = product_variant
    this.setState({
      varients
    })
  }

  deleteProduct(index){
    var varients = this.state.varients
    varients.splice(index, 1);
    this.setState({
      varients
    })
  }

  render() {
    const { classes } = this.props;
    const { varients } = this.state;
    return (
      <>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>Add a Product</h4>
          <p className={classes.cardCategoryWhite}>
            When choosing image, PNG images would be better over JPG or imap
          </p>
        </CardHeader>
        <CardBody>
          <br />
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <ShoppingBasket style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Product Name"
                      value={this.state.product.name}
                      onChange={this.onChange}
                      name="name"
                      id="name"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <MonetizationOn style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Product price"
                      value={this.state.product.price}
                      onChange={this.onChange}
                      name="price"
                      type="number"
                      id="price"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <PlaylistAdd style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Product quantity"
                      value={this.state.product.quantity}
                      onChange={this.onChange}
                      name="quantity"
                      id="quantity"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={3} style={{ marginTop: '10px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.product.isGm}
                    onChange={this.changeIsGmMl.bind(this)}
                    name="isGm"
                  />
                }
                label="Is Gram"
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3} style={{ marginTop: '10px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.product.isMl}
                    onChange={this.changeIsGmMl.bind(this)}
                    name="isMl"
                  />
                }
                label="Is Milliliter"
              />
            </GridItem>
            
            <GridItem xs={12} sm={12} md={3}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <Textsms style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Product description"
                      value={this.state.product.description}
                      onChange={this.onChange}
                      name="description"
                      id="description"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} style={{ marginTop: '10px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.product.isOffer}
                    onChange={this.changeIsOffer.bind(this)}
                    name="isOffer"
                  />
                }
                label="Offer Applicable"
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              {this.state.product.isOffer &&
                <div className={classes.formControl}>
                  <Grid container spacing={1} alignItems="flex-end">
                    <Grid item>
                      <MonetizationOn style={{ color: '#00000090' }} />
                    </Grid>
                    <Grid item>
                      <CustomInputWithIcons
                        labelText="Offer Price"
                        value={this.state.product.offerPrice}
                        onChange={this.onChange}
                        name="offerPrice"
                        id="offerPrice"
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </Grid>
                  </Grid>
                </div>
              }
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <select
                fullWidth={true}
                required="required"
                name="superCategoryId"
                id="inputState"
                className="form-control"
                value={this.state.product.superCategoryId}
                onChange={this.onChangeSelect}
                style={{ marginTop: '2.5em' }}
              >
                {this.props.superCategories.length > 0 ? (
                  this.props.superCategories.map((type) => (
                    <option value={type.id} key={type.id}>
                      {type.name}
                    </option>
                  ))
                ) : (
                    <option disabled="disabled" selected="selected">
                      Select Super-Category
                    </option>
                  )}
              </select>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <select
                fullWidth={true}
                required="required"
                name="categoryId"
                id="inputState"
                className="form-control"
                value={this.state.product.categoryId}
                onChange={this.onChangeSelect2}
                style={{ marginTop: '2.5em' }}
              >
                {this.props.categories.length > 0 ? (
                  this.props.categories.map((type) => (
                    <option value={type.id} key={type.id}>
                      {type.name}
                    </option>
                  ))
                ) : (
                    <option disabled="disabled" selected="selected">
                      Select Category
                    </option>
                  )}
              </select>
            </GridItem>
            {this.state.hiddenSubcategory === 1 ? (
              <GridItem xs={12} sm={12} md={4}>
                <select
                  fullWidth={true}
                  required="required"
                  name="subCategoryId"
                  id="inputState"
                  className="form-control"
                  value={this.state.product.subCategoryId}
                  onChange={this.onChangeSelect2}
                  style={{ marginTop: '2.5em' }}
                >
                  {this.props.subCategories.length > 0 ? (
                    this.props.subCategories.map((type) => (
                      <option value={type.id} key={type.id}>
                        {type.name}
                      </option>
                    ))
                  ) : (
                      <option disabled="disabled" selected="selected">
                        Select sub-category
                      </option>
                    )}
                </select>
              </GridItem>
            ) : (
                ' '
              )}
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} style={{ marginTop: '-14px' }}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item></Grid>
                  <Grid item>
                    <CustomInput
                      labelText="Product Image"
                      id="image"
                      type="file"
                      name="image"
                      accept="image/png, image/jpeg, image/jpg"
                      onChange={this.onUpload}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    <br />
                    <p style={{ color: '#000' }}>
                      {this.state.imageUploadMessage}
                    </p>
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            {varients.map((varient, index) => {
              return (
                <GridItem xs={12} sm={12} md={7} style={{ border: '1px solid', marginTop: '2%', borderRadius: '5px' }}>
                  <Grid container style={{ marginTop: '2%', paddingBottom: '1%' }}>
                    <GridItem xs={12} sm={12} md={5}>
                      <div className={classes.formControl}>
                        <Grid container spacing={1} alignItems="flex-end">
                          <Grid item>
                            <CustomInputWithIcons
                              labelText="Heading"
                              value={varient.heading}
                              onChange={(event) => { this.handleVarientChange(index, event) }}
                              name="heading"
                              id="price"
                              formControlProps={{
                                fullWidth: true
                              }}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                      <div className={classes.formControl}>
                        <Grid container spacing={3} alignItems="flex-end">
                          <Grid item>
                            <Button
                              type="submit"
                              onClick={() => { this.handleVarientAddProduct(index) }}
                              style={{
                                color: '#fff',
                                backgroundColor: '#9c27b0',
                                boxShadow:
                                  '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
                              }}
                            >
                              Add Variant Product
                    </Button>
                          </Grid>
                        </Grid>
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                        <div className={classes.formControl}>
                          <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                              <DeleteOutline style={{cursor:'pointer'}}
                              onClick={(event) => { this.deleteProduct(index) }}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </GridItem>
                  </Grid>
                  {varient.product_variant ? varient.product_variant.map((product_varient, product_index) => {
                    return (<Grid container style={{ marginTop: '2%', paddingBottom: '1%' }}>
                      <GridItem xs={12} sm={12} md={5}>
                        <div className={classes.formControl}>
                          <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                              <CustomInputWithIcons
                                labelText="Name"
                                value={product_varient.name}
                                onChange={(event) => { this.handleVarientProductChange(index, product_index, 'name', event) }}
                                name="price"
                                id="price"
                                formControlProps={{
                                  fullWidth: true
                                }}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={5}>
                        <div className={classes.formControl}>
                          <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                              <CustomInputWithIcons
                                labelText="Price"
                                value={product_varient.price}
                                onChange={(event) => { this.handleVarientProductChange(index, product_index, 'price', event) }}
                                name="price"
                                id="price"
                                type="number"
                                formControlProps={{
                                  fullWidth: true
                                }}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={2}>
                        <div className={classes.formControl}>
                          <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                            <DeleteOutline style={{cursor:'pointer'}}
                              onClick={(event) => { this.deleteProductVariant(index, product_index) }}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </GridItem>
                    </Grid>)
                  }) : ''}
                  <Divider></Divider>
                </GridItem>
              )
            })}
            <GridItem xs={12} sm={12} md={12} style={{ marginTop: '30px' }}>
              <div className={classes.formControl}>
                <Grid container spacing={3} alignItems="flex-end">
                  <Grid item>
                    <Button
                      type="submit"
                      onClick={this.handleVarient}
                      style={{
                        color: '#fff',
                        backgroundColor: '#9c27b0',
                        boxShadow:
                          '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
                      }}
                    >
                      Add Variant
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button
            type="submit"
            onClick={this.onSubmit}
            style={{
              marginLeft: '10px',
              color: '#fff',
              backgroundColor: '#9c27b0',
              boxShadow:
                '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
            }}
          >
            Add Product
          </Button>
        </CardFooter>
        <br /> <br />
        <Table hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Image</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>1</th>
              <td>{this.state.product.name}</td>
              <td>{this.state.product.price}</td>
              <td>{this.state.product.quantity}</td>
              <td>
                <img
                  src={this.state.product.image}
                  style={{ height: '70px' }}
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </>
    );
  }
}

const mapStateWithProps = (state) => ({
  superCategories: state.vendor.superCategories,
  categories: state.vendor.categories,
  subCategories: state.vendor.subCategories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllCategoryList: () => dispatch(getAllCategoryList()),
    getCategoryList: (superCategoryId) =>
      dispatch(getCategoryList(superCategoryId, 1, true)),
    getAllSubCategory: (categoryId) => dispatch(getAllSubCategory(categoryId)),
    addProduct: (product) => dispatch(addProduct(product)),
    upload: (data) => dispatch(upload(data))
  };
};

export default compose(
  connect(mapStateWithProps, mapDispatchWithProps),
  withStyles(styles)
)(AddProduct);
